var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('ve-chart',{attrs:{"height":"100%","data":_vm.chartData,"settings":_vm.chartSettings,"extend":_vm.chartExtends,"loading":_vm.loading,"data-empty":_vm.data.length? false: true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }